<template>
  <div >
    <v-stepper v-model="stepperPage" class="elevation-0" alt-labels >
      <v-stepper-header class="elevation-0" style="" width="500px">
        <v-stepper-step
          :complete="stepperPage > 0"
          step="1"
          complete-icon="mdi-select-search"
          edit-icon="mdi-select-search"
        >
          <p class="text-center">Selecciona tu servicio</p>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="stepperPage > 1"
          step="2"
          complete-icon="mdi-cards"
        >
          <p class="text-center">Escoge los servicios a pagar</p>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="stepperPage > 2"
          step="3"
          complete-icon="mdi-currency-usd"
        >
          <p class="text-center">Realiza el pago en línea</p>
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step step="4" :complete="stepperPage > 3">
          <p class="text-center">Recibe la confirmación</p>
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>

    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "StepperHeaderComponent",
  computed: {
    ...mapState("moduleStepper", ["stepperPage"]),
  },
};
</script>